import React from 'react';
import { BookOpen, Users, Brain, Target, Award, ChevronLeft, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TrainingWorkshop() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700">
              <ChevronLeft className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
            <a 
              href="https://wa.me/60177751631"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 hover:text-green-700"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Contact on WhatsApp</span>
            </a>
          </div>
        </nav>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
          <BookOpen className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">AI Training & Workshop</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive training programs to help your team master AI implementation and strategies.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&q=80"
              alt="Training Session"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold mb-4">Workshop Topics</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• AI Fundamentals and Applications</li>
                <li>• Machine Learning Implementation</li>
                <li>• Data Strategy and Management</li>
                <li>• AI Tools and Platforms</li>
                <li>• Custom Solution Development</li>
              </ul>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-6">Program Features</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Users className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Expert-Led Sessions</h3>
                  <p className="text-gray-600">Learn from industry professionals with real-world AI implementation experience.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Brain className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Hands-On Learning</h3>
                  <p className="text-gray-600">Practice with real AI tools and work on actual implementation scenarios.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Target className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Customized Curriculum</h3>
                  <p className="text-gray-600">Programs tailored to your team's specific needs and industry.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Award className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Certification</h3>
                  <p className="text-gray-600">Receive official certification upon completion of the program.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/#contact"
            className="inline-flex items-center bg-indigo-600 text-white px-8 py-3 rounded-lg hover:bg-indigo-700 transition"
          >
            Schedule a Training Session
          </Link>
        </div>
      </div>
    </div>
  );
}